import ParallaxTilt from "react-parallax-tilt";
import { motion } from "framer-motion";

import { styles } from "../styles";
import { services } from "../constants";
import { SectionWrapper } from "../hoc";
import { fadeIn, textVariant } from "../utils/motion";
import { useIsMobile } from "../hooks/useIsMobile";

const ServiceCard = ({ index, title, icon, isMobile }) => (
  <ParallaxTilt 
    tiltEnable={!isMobile}
    className="w-full sm:w-[280px] mx-auto lg:mx-0"
    options={{
      max: 45,
      scale: 1,
      speed: 450,
    }}
  >
    <motion.div
      variants={fadeIn("right", "spring", index * 0.5, 0.75)}
      className="w-full green-pink-gradient p-[1px] rounded-[20px] shadow-card"
    >
      <div
        className="bg-tertiary rounded-[20px] py-4 px-8 min-h-[260px] flex justify-evenly items-center flex-col"
      >
        <img
          src={icon}
          alt="web-development"
          className="w-16 h-16 object-contain"
        />

        <h3 className="text-foreground text-[20px] font-bold text-center sm:max-w-[145px] sm:min-h-[84px] sm:flex sm:items-center sm:justify-center">
          {title}
        </h3>
      </div>
    </motion.div>
  </ParallaxTilt>
);

const AboutSection = () => {
  const isMobile = useIsMobile();
  return (
    <>
      <motion.div variants={textVariant()}>
        <h2 className={styles.sectionHeadText}>Sobre mí</h2>
      </motion.div>

      <motion.p
        variants={fadeIn("", "", 0.1, 1)}
        className="mt-4 text-secondary about-description text-[17px] max-w-5xl leading-[30px]"
      >
        Soy Ingeniero en Sistemas de Información graduado en la Universidad Tecnológica Nacional (UTN - Argentina - Buenos Aires) con más de 9 años de experiencia
        creando soluciones digitales. Desarrollo de software a medida para startups, PYMES y grandes empresas: 
        aplicaciones web, aplicaciones móviles, Inteligencia Artificial, APIs y sistemas completos con tecnologías como
        React, Node.js, Kotlin, Python y Flutter, desplegados en la nube de GCP, AWS y Firebase.&nbsp;
        <span className="md:hidden">
          Realizo posicionamiento web (SEO) y gestión
          de campañas de Google Ads (SEM) para maximizar la visibilidad de tu negocio online.&nbsp;
        </span>
        <span className="hidden md:inline">
          Realizo posicionamiento web (SEO) y gestión de campañas de Google Ads (SEM)
          para que tu negocio llegue a más clientes.
        </span>
        &nbsp;¿Tenés un proyecto en mente?
        ¡Contactame y hagámoslo realidad ahora!
      </motion.p>
      <div className="mt-20 grid grid-cols-1 lg:grid-cols-3 gap-10 md:gap-10 w-full">
        {services.map((service, index) => (
          <ServiceCard key={service.title} index={index} isMobile={isMobile} {...service} />
        ))}
      </div>
    </>
  );
};

const About = SectionWrapper(AboutSection, "sobre-mi", 0.15);
export default About;
